(function ($) {

    $(document).ready(function () {

        if ($('.quote-slider').length > 0) {

            $('.quote-slider .quote-wrapper').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                infinite: true,
                cssEase: 'linear',
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            draggable: true,
                            variableWidth: false,
                        }
                    },
                    {
                        breakpoint: 595,
                        settings: {
                            arrows: true,
                            slidesToShow: 1,
                            draggable: true,
                            variableWidth: false,
                        }
                    }
                ]
            });
        }
    });

})(jQuery);